import { render, staticRenderFns } from "./ValidationsModal.vue?vue&type=template&id=73c72c83&"
import script from "./ValidationsModal.vue?vue&type=script&lang=js&"
export * from "./ValidationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports